import update from 'immutability-helper';

// ------------------------------------
// Constants
// ------------------------------------
export const SET_FB_PIXEL_ID = 'SET_FB_PIXEL_ID';

export function setFbPixelId(fbPixelId) {
	return {
		type: SET_FB_PIXEL_ID,
		fbPixelId,
	};
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
	[SET_FB_PIXEL_ID]: (state, action) => update(state, {
		fbPixelId: { $set: action.fbPixelId },
	}),
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
	fbPixelId: null,
};

export default function reducerFunction(state = initialState, action) {
	const handler = ACTION_HANDLERS[action.type];
	return handler ? handler(state, action) : state;
}
